"use client";

import Image from "next/image";
import { css, cx } from "styled-system/css";

const IMAGE_SCROLL_RANGE = "100vh";

interface BackgroundImageProps {
  src: string;
  alt?: string;
}

export function BackgroundImage({ src, alt = "" }: BackgroundImageProps) {
  return (
    <>
      <style>{`
        @keyframes imageScrollAway {
          from { transform: translate3d(0, 0, 0); }
          to { transform: translate3d(0, -100vh, 0); }
        }
      `}</style>
      <div className={cx(backgroundImageStyles, scrollDrivenImageStyles)}>
        <Image src={src} alt={alt} fill className={imageStyles} unoptimized priority />
      </div>
    </>
  );
}

const backgroundImageStyles = css({
  position: "fixed",
  w: "full",
  h: { base: "[100vh]", md: "auto" },
  aspectRatio: { base: "auto", md: "[1728 / 1568]" },
  top: "0",
  zIndex: "[-1]",
});

const scrollDrivenImageStyles = css({
  "@supports (animation-timeline: scroll())": {
    animation: "imageScrollAway linear both",
    animationTimeline: "scroll(root block)",
    animationRange: `0 ${IMAGE_SCROLL_RANGE}`,
  },
});

const imageStyles = css({
  objectFit: "cover",
});
